var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jsmb-account-information-detail"},[_c('h2',{staticClass:"jsmb-title-detail is-size-4 has-text-text"},[_vm._v("CGU")])])}]

export { render, staticRenderFns }